import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const SupplyCapWarningComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      className="nostra__icon nostra__icon__supplyCapWarning"
      width={size}
      height={size}
      viewBox="0 0 23 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11.6667" cy="11" r="9" stroke="#E8EAEE" strokeWidth="4" />
      <path
        d="M11.6667 2C16.6373 2 20.6667 6.02944 20.6667 11C20.6667 15.9706 16.6373 20 11.6667 20C6.69619 20 2.66675 15.9706 2.66675 11C2.66675 7.06846 5.18766 3.72571 8.70126 2.5"
        stroke={colorVar}
        strokeWidth="4"
      />
      <path
        d="M11.6667 8.32996V10.9966"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 13.6633H11.6734"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const SupplyCapWarning = withIcon(SupplyCapWarningComponent);
